/* eslint-disable no-underscore-dangle */
import React, { useEffect } from 'react';
import {
    Spin, Button, Table, Tooltip,
} from 'antd';
import { MessageOutlined, CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Title from 'antd/lib/typography/Title';
import {
    getAllQueriesAsync,
    setQueryList,
    selectQueryAsync,
    updateQueryAsync,
} from '../../../redux/query/actions';
import { formatDateTimeFromIso } from '../../../helpers/functions';


const QueryList = ({
    user,
    contentIsLoading,
    queryList,
    getAllQueriesAsync,
    setQueryList,
    selectQueryAsync,
    updateQueryAsync,
}) => {
    useEffect(() => {
        if (user) {
            const query = user.type === 1 ? '?status=answered&isCallCenterAgent=true' : '?status=answered';
            getAllQueriesAsync(query);
        }
        return () => {
            setQueryList([]);
        };
    }, [user]);

    const columns = [
        {
            title: <b>Nature</b>,
            key: 'queryName',
            render: (_, record) => <p>{record.field.label}</p>,
        },
        {
            title: <b>Patient </b>,
            key: 'name',
            render: (_, record) => (
                <p>
                    {`${record.patient.firstName ? record.patient.firstName.value : ''} ${
                        record.patient.lastName ? record.patient.lastName.value : ''
                    }`}
                </p>
            ),
        },
        {
            title: <b>Date de l&apos;appel </b>,
            key: 'call',
            render: (_, record) => (
                <p>{formatDateTimeFromIso(record.call.createdAt)}</p>
            ),
        },
        {
            title: <b> Date d&apos;envoi</b>,
            key: 'date',
            render: (_, record) => <p>{formatDateTimeFromIso(record.createdAt)}</p>,
        },
        {
            title: <b> Actions </b>,
            key: '_id',
            render: (_, record) => (
                <div className="flex">
                    <>
                        <Tooltip className="m-left-medium" title="Répondre">
                            <Button
                                type="text"
                                shape="circle"
                                onClick={() => {
                                    selectQueryAsync(record._id);
                                }}
                                className="field-action-icon color-green"
                                icon={<MessageOutlined />}
                            />
                        </Tooltip>

                        <Tooltip className="m-left-medium" title="Fermer">
                            <Button
                                type="text"
                                shape="circle"
                                onClick={() => {
                                    updateQueryAsync(record._id, { status: 'closed' });
                                }}
                                className="field-action-icon color-red"
                                icon={<CloseOutlined />}
                            />
                        </Tooltip>
                    </>
                </div>
            ),
        },
    ];

    if (user && user.type !== 2) {
        columns.splice(-1, 1);
    }

    return (
        <Spin spinning={contentIsLoading}>
            <div className="section-content">
                <Title level={5}>
                    Queries traitées
                </Title>
                <Table
                    className="m-top-medium"
                    columns={columns}
                    dataSource={queryList}
                    locale={{ emptyText: 'Aucun événement' }}
                />
            </div>
        </Spin>
    );
};

QueryList.propTypes = {
    queryList: PropTypes.array.isRequired,
    getAllQueriesAsync: PropTypes.func.isRequired,
    contentIsLoading: PropTypes.bool.isRequired,
    setQueryList: PropTypes.array.isRequired,
    user: PropTypes.object,
    selectQueryAsync: PropTypes.func.isRequired,
    updateQueryAsync: PropTypes.func.isRequired,
};

QueryList.defaultProps = {
    user: null,
};

const stateToProps = state => ({
    user: state.auth.user,
    queryList: state.queries.queryList,
    contentIsLoading: state.loading.contentIsLoading,
});

const dispatchToProps = dispatch => bindActionCreators(
    {
        getAllQueriesAsync,
        selectQueryAsync,
        setQueryList,
        updateQueryAsync,
    },
    dispatch,
);

export default connect(stateToProps, dispatchToProps)(QueryList);
